import styled from "styled-components";

export const CardWrapper = styled.div`
    position: relative;
    max-width: 300px;
    width: 100%;
    text-align: center;
    overflow: hidden;
    ${props => !props.$isFeatured ? 'border-bottom-left-radius: 3px;':'border-bottom-right-radius: 3px;'}
    ${(props) =>
    props.$isFeatured &&
    `
                      box-shadow: 0 0 35px 2px rgba(0, 0, 0, .2);
                  z-index: 10;
                `}
    &:first-child {
        margin-right: -3px;
    }
    transition: 0.2s;
    @media screen and (max-width: 767px){
        max-width: 100%;
    }
`;
export const FeaturedBadge = styled.div`
    position: absolute;
    top: 15px; 
    left: -35px; 
    transform: rotate(-45deg);
    background-color: #ffd565;
    color: #7b683c;
    padding: 5px 35px;
    line-height: 12px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-shadow: 0 1px 0 rgba(255, 255, 255, .5);
    box-shadow: 0 3px 0 0 rgba(0, 0, 0, .1);
`;
export const HeaderWrapper = styled.div`
    border-top-left-radius: 3px;
    ${props => props.$isFeatured &&"border-top-right-radius: 3px;"}
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .2);
    background-color: ${(props) => (props.$isFeatured ? '#2bc2d5' : '#25ae8d;')};;
`
export const CardHeader = styled.div`
    padding: ${(props) => (props.$isFeatured ? '30px 20px' : '20px')};
    background-color: rgba(0, 0, 0, .2);
    color: white;
    font-size: 16px;
    font-weight: lighter;
    line-height: 16px;
    text-transform: uppercase;
    text-shadow: 1px 1px 0 rgba(0, 0, 0, .3);
`;
export const CardPriceSection = styled.div`
    color: white;
    font-size: 65px;
    font-weight: 700;
    text-shadow: 1px 1px 0 rgba(0, 0, 0, .3);
    height: 120px;
    display: flex;
    justify-content: center;
    text-align: center;
    border-top: 1px solid rgba(255, 255, 255, .2);
    padding: 25px 0;
    & > sup{
        font-size: 24px;
        padding: 0 5px;
        font-weight: 400;
    }
`;
export const FeatureList = styled.ul`
    background-color: #F8F9FA;
    border-left: 1px solid #e8e8e8;
    border-right: 1px solid #e8e8e8;
`;
export const CardSubHeader = styled.li`
    display: block;
    padding: 15px;
    font-size: 12px;
    line-height: 16px;
    font-weight: bold;
    text-transform: uppercase;
    color: #0077b3;
    background-color: #eee;
`;
export const FeatureItem = styled.li`
    padding: 15px;
    font-size: 12px;
    line-height: 16px;
    color: #6C757D;
    &:nth-child(2n-1){
        background-color: #eee;
    }
    &:last-child {
      border-bottom: none;
     }
`;